import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLoading } from '../../../components/LoadingContext/LoadingContext';
import { questionnaireService } from '../services/questionnaireService';
import { Question } from '../types/questionnaire.types';

interface UseBuscarQuestaoPesquisareturn {
  data: Question | undefined;
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

export const useBuscarQuestaoPesquisa = (
  eventUId: string
): UseBuscarQuestaoPesquisareturn => {
  const { startLoading, stopLoading } = useLoading();
  const history = useHistory();

  const { data, isLoading, isError, error, refetch } = useQuery<
    Question,
    Error
  >({
    queryKey: ['evento-usecase002-getPesquisa', eventUId],
    queryFn: () => questionnaireService.getPesquisa(eventUId).then(),
    enabled: !!eventUId,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  // Tratamento de erro
  useEffect(() => {
    if (isError) {
      toast.error('Nenhum resultado foi encontrado.');
      setTimeout(() => {
        history.push('/home-user');
      }, 4000);
    }
  }, [isError, history]);

  // Sincroniza com LoadingContext
  useEffect(() => {
    if (isLoading) {
      startLoading();
    } else {
      stopLoading();
    }
  }, [isLoading, startLoading, stopLoading]);

  return {
    data,
    isLoading,
    error: isError ? error : null,
    refetch,
  };
};
